import { addAlert } from "service/CSRAdminAlerts";
import { useTranslation } from "react-i18next";

function CancelForm({
  alert,
  setConfirmationModal,
  setConfirmationMessage,
  setAlertEditCancel,
}) {
  const { t } = useTranslation();
  const cancelAlert = async () => {
    const { id, userId } = alert;

    await addAlert({
      userId: userId,
      id: id,
      isActive: 0,
    }).then((res) => {
      if (res.ok) {
        setConfirmationMessage(t("AgentCSR-Admin-CancelForm-message-1"));
        setConfirmationModal(true);
        setAlertEditCancel(false);
      } else {
        setConfirmationMessage(t("AgentCSR-Admin-CancelForm-message-2"));
        setConfirmationModal(true);
        setAlertEditCancel(false);
      }
    });
  };

  return (
    <>
      <div className="grid grid-cols-2 mt-6">
        <button
          className="ui-btn-secondary xl:text-lg"
          onClick={() => setAlertEditCancel(false)}
        >
          {t("AgentCSR-Admin-CancelForm-button-1")}
        </button>
        <button
          className="ui-btn-primary xl:text-lg"
          onClick={() => cancelAlert()}
        >
          {t("AgentCSR-Admin-CancelForm-button-2")}
        </button>
      </div>
    </>
  );
}

export default CancelForm;
